type DashboardTrip = {
  [x: string]: number;
}

export const mountDashboardTrips = (result: DashboardTrip) => {
  return {
    allTrips: result.allTrips,
    scheduled: result.schedules,
    new: result.suggestion,
    pending: result.pending,
    refused: result.refused,
    canceled: result.canceled,
    acomplished: result.acomplished,
  };
};